import React, { useEffect, useState } from "react";
import { Form, InputNumber } from "antd";

function Int({
  form,
  textColor,
  name,
  controlHeight = 40,
  min,
  max,
  defaultValue,
  label,
  width,
  labelCol,
  required,
  errorMessage,
  validateFunction,
  placeholder,
  disabled,
  size,
}) {
  const [minMaxStatus, setMinMaxStatus] = useState("");
  const [minMaxError, setMinMaxError] = useState("");

  useEffect(() => {
    form.setFieldsValue({ [name]: defaultValue });
    if (defaultValue?.toString()) {
      handleValueChange(defaultValue);
    }
  }, [])

  const handleValueChange = (value) => {
    let status = "";
    let msg = "";

    if ((value === null || value === undefined || value === "") && required) {
      setMinMaxStatus("");
      setMinMaxError("");
      return;
    }

    if (min?.val?.toString() && value < min?.val) {
      status = "error";
      msg = min?.errorMessage;
    } else if (max?.val?.toString() && value > max?.val) {
      status = "error";
      msg = max?.errorMessage;
    }

    setMinMaxStatus(status);
    setMinMaxError(msg);
  };

  return (
    <Form.Item
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      {...(minMaxStatus && { validateStatus: minMaxStatus, help: minMaxError || undefined })}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
      ]}
    >
      <InputNumber
        disabled={disabled}
        size={size ? size : "large"}
        style={{ width: "100%", backgroundColor: "#fff", fontWeight: 600, minHeight: controlHeight, color: textColor }}
        placeholder={placeholder}
        onChange={handleValueChange}
      />
    </Form.Item>
  );
}

export default Int;
